export default {
    editar: "Editar",
    eliminar: "Eliminar",
    confirmar: "Confirmar",
    cancelar: "Cancelar",
    cerrar: "Cerrar",
    guardar: "Guardar",
    noData: "No se encontraron datos",
    renovar: "Renovar",
    comprar: "Comprar",
    volver: "Volver",
    limpiarFiltros: "Limpiar filtros",
    imprimir: "Imprimir",
    exportar: "Exportar a excel",
    filtrar: "Filtrar",
    si: "Si",
    no: "No",
    todos: "Todos",
    descargar: "Descargar",
    ninguno: "Ninguno",
    msgError: "Ha ocurrido un error",
    msgExito:"La operación se ha realizado con éxito",
    noDefinido: "No definido",
    msgOrdenFinalizada: "No se puede completar la acción porque la orden fue finalizada",
    continuar: "Continuar",
    msgNroInvalido: "Por favor ingresa un número válido",
    msgCampoRequerido: "Completa todos los datos", //"Es requerido",  
    verDetalle: "Ver detalle",
    msgEspera: "Por favor espera...",
    seleccionar: "Seleccionar",
    seleccionado: "Seleccionado",
    monedaNacional: "Moneda Nacional",
    dolares: "Dolares",
    'Moneda Nacional': "Moneda Nacional",
    Dolares: "Dolares",
    msgImagenInvalida: "Formato de imagen inválida, solo se permite .png, .jpg o .jpeg",
    msgErrorEmailDuplicado: "Ya existe un cliente registrado con este email en esta cuenta",
    msgSeleccioneOpcion:"Debes seleccionar una opción",
    generar: "Generar",
    linkTerminos: "https://satweb.cl/terminos-de-uso"
}